import React, { useEffect } from 'react';
import Hometopimage from '../../assets/images/civiltopimage.webp';
import interiormiddle from '../../assets/images/interiormiddle.webp';
import interiorvillaoutfit from '../../assets/images/interiorvillaoutfit.jpg';
import interirorofficeoutfit from '../../assets/images/interirorofficeoutfit.jpg';
import interirorshopoutfit from '../../assets/images/interirorshopoutfit.jpg';
import office from '../../assets/images/ofi.png';
import villa from '../../assets/images/vil.png';
import hotel from '../../assets/images/hotell.png';
import restaurant from '../../assets/images/restaurant.png'
import showroom from '../../assets/images/sh.png';
import supermarket from '../../assets/images/superm.png';

//aos animation
import AOS from 'aos';
import 'aos/dist/aos.css';

//icons

import Running from '../../components/Movingimg/Moving';
import Testimonial from '../../components/Testimonials/Testimonial';
import Ourleaders from '../../components/Ourleaders/Ourleaders';
import { Link } from 'react-router-dom';
import Metatag from '../../components/Metatag/Metatag';


const Interior = () => {
  useEffect(() => {
    // Scroll to the top when the page loads
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init({
      once: true,
    })
  })
  const ourExpertise = [
    {
      img: office,
      heading: "Office Fitouts",
      text: "Office fit-outs are key to transforming work environments, promoting productivity and comfort. They optimize space, incorporate ergonomic furniture, and integrate modern technology seamlessly. Balancing open and private areas ensures flexibility, while reflecting brand identity in the design creates a cohesive atmosphere. Sustainable practices and modular designs allow for future growth and adaptability, making office fit-outs an essential investment for businesses looking to improve their workspace.",
    },
    {
      img: villa,
      heading: "Villa Fitouts",
      text: "Villa fit-outs are designed to create luxurious, personalized living spaces that blend style with functionality. They focus on optimizing room layouts, ensuring comfort, and integrating high-quality materials and finishes. Each fit-out reflects the homeowner's lifestyle, incorporating bespoke elements like custom furniture, smart home technology, and tailored lighting. With an emphasis on elegance and attention to detail, villa fit-outs bring a unique touch to every corner, creating a harmonious and sophisticated living environment.",
    },
    {
      img: restaurant,
      heading: "Restautant Fitouts",
      text: "Restaurant fit-outs are vital in creating an inviting atmosphere that enhances the dining experience. They focus on efficient space planning, ensuring smooth flow for both staff and customers. From selecting durable materials to incorporating themed décor, the design reflects the restaurant's concept and brand. "

    },
    {
      img: hotel,
      heading: "Hotel Fitouts",
      text: "Hotel fit-outs are all about creating elegant, comfortable spaces that offer guests a premium experience. They focus on crafting functional yet aesthetically pleasing areas, from lavish lobbies to cozy guest rooms. High-quality materials, bespoke furnishings, and smart technology are integrated to ensure convenience and luxury. "
    },
    {
      img: supermarket,
      heading: "Supermarket  Fitouts",
      text: "Supermarket Fit-outs: Enhancing Shopper Experience Supermarket fit-outs are crucial for creating a functional, efficient, and welcoming shopping environment. They focus on optimizing the layout to facilitate smooth traffic flow and easy access to various product sections. Shelving, signage, and checkout areas are strategically designed to improve product visibility and customer convenience. "

    },
    {
      img: showroom,
      heading: "Showroom   Fitouts",
      text: "Showroom fit-outs are designed to create a visually stunning environment that highlights products and attracts customers. They focus on optimizing space for product displays, ensuring ease of movement and clear sightlines. Lighting plays a key role in emphasizing features and details, while carefully selected materials and finishes enhance the brand’s aesthetic. "

    }
  ]
  return (
    <div className=' '>
      <Metatag title="Interior Design Services Creative Interior Solutions" description="Elevate your space with professional interior design services. Our expert team offers personalized design,and renovation for residential and commercial projects" link="interior"/>
      <div className=' relative bg-cover overflow-hidden bg-no-repeat bg-center w-full h-full' style={{ backgroundImage: `url(${Hometopimage})`, backgroundRepeat: 'no-repeat' }}>
        <div className=' absolute inset-0 bg-black  opacity-45'></div>
        <div className='  relative  p-3 sm:p-12 pb-8 sm:pb-20' data-aos="fade-left" data-aos-duration="2000">

          <h1 className=' mt-2 sm:mt-6 text-[#feb231] font-bold text-2xl sm:text-4xl'><span className=' text-black text-3xl sm:text-6xl'>Interior</span> Fit Out</h1>
          <h1 className=' mt-1 sm:mt-2 text-[#feb231] font-bold text-2xl sm:text-5xl'>Contractor <span className=' text-black text-3xl sm:text-6xl'>Dubai</span> </h1>
          <p className=' mt-2 sm:mt-4 text-xl text-white'>With a focus on excellence, our team materializes visions into reality, </p>
          <p className='  text-xl text-white'>producing spaces that surpass all expectations.</p>
          <Link to='/contactus'>

            <button className=' bg-[#feb231] rounded-xl px-3 p-2 mt-8 text-[#000000] font-semibold hover:shadow-[1px_4px_1px_0px_rgba(0,0,1)]' >
              Stay Connect
            </button>
          </Link>

        </div>
      </div>
      <div className=' bg-[#000000eb]'>
        <div className=' p-3 lg:p-1 sm:pt-7  container'>
          <div data-aos="fade-up" data-aos-duration="1500">
            <h1 className="mb-4 text-2xl pt-6 font-bold  text-orange text-center md:text-4xl">Meeting Your Varied Needs with Excellence</h1>
            <p className="text-sm md:text-base text-white text-center pt-2 leading-6">At Megavolt, we recognize that innovation and professionalism are crucial to success. That's why we collaborate with top talent in the industry to ensure we deliver outstanding results tailored to your specific requirements.</p>

          </div>
          <div className=' grid grid-flow-row grid-cols-1  md:grid-cols-3 gap-5  mt-6 sm:mt-12 pb-6  overflow-hidden'>
            <div className=' overflow-hidden rounded-xl ' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="100" >
              <img src={interirorshopoutfit} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Substation' />
              <p className='pt-4 text-center font-semibold text-white'>Shop Fitout</p>
            </div>
            <div className=' overflow-hidden rounded-xl' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="300" >
              <img src={interirorofficeoutfit} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Villa Development' />
              <p className='pt-4 text-center font-semibold text-white'>Office Fitout</p>
            </div>
            <div className=' overflow-hidden rounded-xl' data-aos="zoom-in" data-aos-duration="1000" data-aos-delay="500" >
              <img src={interiorvillaoutfit} className='w-full h-48 sm:h-56 lg:h-64 object-cover rounded-xl hover:scale-[1.05] ease-linear transition-transform duration-200' alt='Substation' />
              <p className='pt-4 text-center font-semibold text-white'>Villa Fitout</p>
            </div>
          </div>
        </div>
      </div>
      <div className=' bg-[#f7b12d] p-3 lg:p-1 pb-5 lg:pb-10'>
        <div className='  pt-4 sm:pt-9 sm:w-[90%] mx-auto'>
          <p className="mb-4 text-2xl pt-1 font-bold  text-center md:text-4xl">Our Expertise</p>
          <p className=' text-[18px] sm:text-xl pt-2 sm:pt-4 text-[#fff] text-justify sm:text-center'>We take pride in offering a wide range of specialized interior fitting contractor services, each meticulously crafted to meet the unique needs of our clients. Discover our areas of expertise, where we transform spaces into remarkable environments tailored to your vision. </p>
        </div>
        <div className='container gap-4 sm:gap-8 grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 grid-flow-row pt-4 sm:pt-9'>
          {ourExpertise.map((item, index) => (
            <div className='bg-[#fff] rounded-[20px]  hover:shadow-[0px_0px_8px_0px_rgba(0,0,1)] hover:-translate-y-1 sm:hover:-translate-y-3 hover:ease-linear transition-transform duration-300' key={index} >
              <div className=' bg-[#f7b12d;] mx-auto w-max rounded-[50%] mt-3  '>
                <img src={item.img} className=' h-20 w-20 object-contain p-5 rounded-[50%]' alt={item.img} />
              </div>
              <p className=' text-[black] text-center pt-4 font-bold text-2xl'>{item.heading}</p>
              <p className="text-sm md:text-base text-[#7a7a7a] text-justify  p-4 mb-2 leading-6">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
      {/* our leaders */}
      {/* <Ourleaders /> */}
      <div className=' bg-[#feb231]'>
        <div className=' container  pt-2 sm:pt-6 pb-2  '>
          <div className='grid grid-flow-row grid-cols-12 gap-2  p-3  text-justify rounded-tr-[120px] bg-gradient-to-r from-black to-[#2e3534] group-hover:bg-gradient-to-r group-hover:from-[#feb231] group-hover:to-[#feb231b8]'>
            <div className=' hidden md:block sm:col-span-4'>
              <img src={interiormiddle} className=' w-full  h-full mt-[-20px] object-cover' alt='image' />
            </div>
            <div className='  col-span-12 sm:col-span-8 p-4 '>
              <p className=' text-3xl font-bold  pt-12 text-[#feb231] group-hover:text-black  '> Ready to Elevate Your Projects?</p>
              <p className=' text-white pt-8 leading-7  group-hover:text-black  '>Our team at Megavolt Contracting LLC is committed to bringing your vision to life in remarkable ways. We understand that each project is unique, which is why we take the time to listen to your ideas and objectives. Embark on this journey with us, where we challenge design conventions and foster innovation. Together, we will explore new possibilities and create spaces that resonate with your aspirations. Our team at Megavolt Contracting LLC is dedicated to realizing your ideas in ways that impress. Join us on this journey as we push the boundaries of design and inspire creativity. Experience the difference of working with a team that values your input and strives for excellence in every detail. Let’s make your project a standout success!
              </p>
            </div>
          </div>
        </div>
      </div>
      <Testimonial />
      <Running />
    </div>
  )
}

export default Interior